import { GraphQLClient } from "graphql-request";

// Environment variables for Shopify Storefront API 2024-01
const SHOPIFY_STOREFRONT_TOKEN_2024_01 = process.env.GATSBY_SHOPIFY_STOREFRONT_TOKEN_2024_01;
const SHOPIFY_GRAPHQL_URL_2024_01 = process.env.GATSBY_SHOPIFY_GRAPHQL_URL_2024_01;

// Validate required environment variables
if (!SHOPIFY_STOREFRONT_TOKEN_2024_01) {
  throw new Error("GATSBY_SHOPIFY_STOREFRONT_TOKEN_2024_01 environment variable is required");
}

if (!SHOPIFY_GRAPHQL_URL_2024_01) {
  throw new Error("GATSBY_SHOPIFY_GRAPHQL_URL_2024_01 environment variable is required");
}

// Create GraphQL client for Shopify Storefront API 2024-01
export const shopifyClient = new GraphQLClient(SHOPIFY_GRAPHQL_URL_2024_01, {
  headers: {
    "X-Shopify-Storefront-Access-Token": SHOPIFY_STOREFRONT_TOKEN_2024_01,
    "Content-Type": "application/json",
  },
});

// API configuration object for easy access
export const shopifyApiConfig = {
  client: shopifyClient,
  token: SHOPIFY_STOREFRONT_TOKEN_2024_01,
  url: SHOPIFY_GRAPHQL_URL_2024_01,
};

// Helper function to make GraphQL requests
export const makeShopifyRequest = async <T = any>(query: string, variables?: Record<string, any>): Promise<T> => {
  try {
    const response = await shopifyClient.request<T>(query, variables);
    return response;
  } catch (error) {
    console.error("Shopify API request failed:", error);
    throw new Error(`Shopify API request failed: ${error instanceof Error ? error.message : "Unknown error"}`);
  }
};

// Export configuration for use in other files
export default shopifyApiConfig;
